<template>
  <nav class="header" :class="{ fixed: isFixed }">
    <div class="container navInner">
      <router-link to="/" class="logo">
        <img src="../assets/logo.jpg" alt="ADLCJ" />
      </router-link>
      <div class="navLinks" :class="{ open: menuOpen }">
        <router-link to="/ecole" @click.native="menuOpen = false">{{ $t("menu.ecole") }}</router-link>
        <router-link to="/cours-japonais" @click.native="menuOpen = false">Cours de japonais</router-link>
        <router-link to="/adlcj" @click.native="menuOpen = false">{{ $t("adlcj.h1") }}</router-link>
        <router-link to="/recrutement" @click.native="menuOpen = false">{{ $t("recrutement.h1") }}</router-link>
        <router-link to="/contact" @click.native="menuOpen = false">{{ $t("contact.h1") }}</router-link>
      </div>
      <div class="navActions">
        <button class="langBtn" @click="changeLocale" :aria-label="$i18n.locale === 'ja' ? 'Passer en français' : '日本語に切り替える'">
          <img
            v-if="$i18n.locale === 'ja'"
            src="../assets/image/icons/flag-fr2.svg"
            alt="Passer en français"
            class="flagIcon"
          />
          <img
            v-else
            src="../assets/image/icons/flag-jp2.svg"
            alt="日本語に切り替える"
            class="flagIcon"
          />
        </button>
        <button class="burgerBtn" @click="menuOpen = !menuOpen" :aria-label="menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'">
          <img src="../assets/image/icons/menu-burger.svg" alt="" aria-hidden="true" width="24" height="24" />
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      isFixed: true,
      lastScrollPosition: 0,
      menuOpen: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    changeLocale() {
      this.$emit("change-locale");
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 88) {
        return;
      }
      this.isFixed = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
  },
  computed: {
    langType: function () {
      return {
        fr: this.$i18n.locale === "fr",
      };
    },
  },
};
</script>

<style lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: white;
  z-index: 100;
  transition: box-shadow 0.2s, height 0.2s;

  &.fixed {
    box-shadow: 0 2px 10px rgba(97, 93, 93, 0.4);
  }
}

.navInner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.logo {
  flex-shrink: 0;
  height: 38px;
  img {
    height: 100%;
    width: auto;
  }
}

.navLinks {
  display: flex;
  align-items: center;
  gap: 24px;

  a {
    font-size: 14px;
    font-weight: 600;
    color: $textColor;
    text-decoration: none;
    white-space: nowrap;

    &:hover,
    &.router-link-active {
      color: $accentColor;
    }
  }
}

.navActions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.langBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s, transform 0.2s;

  .flagIcon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
  }

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

.burgerBtn {
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

@media (max-width: 767px) {
  .burgerBtn {
    display: flex;
  }

  .navLinks {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);

    &.open {
      display: flex;
    }

    a {
      width: 100%;
      padding: 12px 20px;
      border-bottom: 1px solid #eaeaea;
    }
  }
}

@media (min-width: 768px) {
  .header {
    height: 70px;
  }
  .logo {
    height: 44px;
  }
}

@media (min-width: 992px) {
  .header {
    height: 88px;
  }
  .logo {
    height: 50px;
  }
  .navLinks {
    gap: 32px;
  }
}
</style>